function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#693cc5;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-EMR_Cluster_light-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("rect", {
  className: "cls-2",
  x: 16.85,
  y: 12.1,
  width: 10.23,
  height: 2,
  transform: "translate(-3.35 16.78) rotate(-39.07)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 21.12,
  y: 32.11,
  width: 2,
  height: 9.83,
  transform: "translate(-20.56 30.86) rotate(-50.92)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 27.75,
  y: 19.13,
  width: 2,
  height: 21.74,
  transform: "translate(-8.8 47.77) rotate(-71.55)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 17.88,
  y: 19,
  width: 21.74,
  height: 2,
  transform: "matrix(0.95, -0.32, 0.32, 0.95, -4.85, 10.12)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 33.84,
  y: 9.05,
  width: 2,
  height: 21.58,
  transform: "translate(-5.12 23.14) rotate(-34.38)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M42.49,13.6c-3.36-2.64-8.65-6.5-8.7-6.54L35,5.44c.06,0,5.38,3.92,8.77,6.59Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M34.38,11.94H25.94a1,1,0,0,1-1-1V2.5a1,1,0,0,1,1-1h8.44a1,1,0,0,1,1,1v8.44A1,1,0,0,1,34.38,11.94Zm-7.44-2h6.44V3.5H26.94Z"
}), React.createElement("rect", {
  className: "cls-2",
  x: 24.05,
  y: 29.16,
  width: 21.58,
  height: 2,
  transform: "translate(-9.72 41.89) rotate(-55.63)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M35,44.56l-1.17-1.62c.05,0,5.34-3.9,8.7-6.54L43.73,38C40.34,40.64,35,44.52,35,44.56Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M34.38,48.5H25.94a1,1,0,0,1-1-1V39.06a1,1,0,0,1,1-1h8.44a1,1,0,0,1,1,1V47.5A1,1,0,0,1,34.38,48.5Zm-7.44-2h6.44V40.06H26.94Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M47.5,38.19H39.06a1,1,0,0,1-1-1V28.75a1,1,0,0,1,1-1H47.5a1,1,0,0,1,1,1v8.44A1,1,0,0,1,47.5,38.19Zm-7.44-2H46.5V29.75H40.06Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M47.5,22.25H39.06a1,1,0,0,1-1-1V12.81a1,1,0,0,1,1-1H47.5a1,1,0,0,1,1,1v8.44A1,1,0,0,1,47.5,22.25Zm-7.44-2H46.5V13.81H40.06Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M10.47,37.25c-4.32,0-9-1.2-9-3.83V17.25c0-2.63,4.65-3.83,9-3.83s9,1.2,9,3.83V33.42C19.44,36.05,14.79,37.25,10.47,37.25Zm0-21.83c-4.57,0-7,1.36-7,1.83V33.42c0,.47,2.4,1.83,7,1.83s7-1.36,7-1.83V17.25C17.44,16.78,15,15.42,10.47,15.42Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M10.47,20.59c-4.32,0-9-1.2-9-3.83h2c0,.47,2.4,1.83,7,1.83s7-1.36,7-1.83h2C19.44,19.39,14.79,20.59,10.47,20.59Z"
}));

var SvgAwsEmrCluster = function SvgAwsEmrCluster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsEmrCluster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-EMR_Cluster.1f323c5a.svg";
export { ForwardRef as ReactComponent };